import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { EnrollmentService } from 'src/app/services/enrollment.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { OnetimepasswordService } from 'src/app/services/onetimepassword.service';
import { PersistenceService } from 'src/app/services/persistence.service';

@Component({
    selector: 'app-otp',
    templateUrl: './otp.component.html',
    styleUrls: ['./otp.component.scss'],
    standalone: false
})
export class OtpComponent {  
  
  /*
    get to login page
    enter email address
    make call to get censored SMS and Email
    select one, service call to send OTP
    box for entering OTP, service call to confirm OTP
    Once verified, set auth token
  */
  @ViewChild('loginForm') loginForm: NgForm;
  @ViewChild('loginForm2') loginForm2: NgForm;
  @ViewChild('loginForm3') loginForm3: NgForm;
  emailAddress;
  businessEmail;
  personalEmail;
  travelArrangerEmail;
  errorMsg;
  enrlErrMsg;
  isFormCompleted=false;
  isFormCompleted2=false;
  isFormCompleted3=false;
  isSubmitting1 = false;
  isSubmitting2 = false;
  isSubmitting3 = false;
  header;
  emailEntryMode=true;
  //{{"copy.label.OTP.emailEntry"|copy|async}}
  methodSelectMode=false;
  //{{"copy.label.OTP.methodSelect"|copy|async}}
  confirmMode=false;
  //copy.label.OTP.confirmationCodeHeader
  method;
  smsnumber;
  email;
  confirmcode='';
  otpSessionID;
  guid;
  constructor(private auth:AuthenticationService, private otpService: OnetimepasswordService,private router: Router, private persistence: PersistenceService, private navigation:NavigationService, private enrollmentService: EnrollmentService) { }

  ngOnInit(): void {
    
  }

  emailEnter(){
    if(this.loginForm.valid && !this.isSubmitting1){
      this.isSubmitting1 = true;

      this.otpService.registerOTP(this.emailAddress).subscribe((data:any)=>{
        // this.otpKey = data.key;
        this.email = data.email;
        this.guid = data.guid;
        this.businessEmail = data.businessEmail;
        this.personalEmail = data.personalEmail;
        this.travelArrangerEmail = data.travelArrangerEmail;
        this.smsnumber = data.phone;
        this.emailEntryMode =false;
        this.methodSelectMode = true;
        this.isSubmitting1 = false;
      },()=>{
        this.isSubmitting1 = false;
      });    
    }
  }

  backToSelect(){
    this.emailEntryMode =true;
    this.methodSelectMode = false;
  }

  methodSelect(){
    if(this.loginForm2.valid && !this.isSubmitting2){
      this.isSubmitting2 = true;
      this.otpService.selectMethod(this.method, this.guid).subscribe((data:any)=>{
        this.otpSessionID = data.sessionID;
        this.methodSelectMode = false;
        this.confirmMode = true;
        this.isSubmitting2 = false;
      },()=>{
        this.isSubmitting2 = false;
      });
    }
  }

  confirm(){
    
    if(this.loginForm3.valid && !this.isSubmitting3){
      this.isSubmitting3 = true;
      this.errorMsg = false;
      this.enrlErrMsg = false;

      this.otpService.validateOTP(this.confirmcode, this.otpSessionID,this.method,this.guid).subscribe((data:any)=>{
        this.auth.authtoken = data;
        this.enrollmentService.rvsGetEnrollment().then(() => {        
          this.navigation.forwardrvs();
          this.isSubmitting3 = false;
        }).catch(()=>{
          console.log("enroll error");
          this.enrlErrMsg = true;
          this.isSubmitting3 = false;

        });
      },()=>{
        this.errorMsg = true;
        this.isSubmitting3 = false;
      });
    }
  }

  resend(){
    this.errorMsg = false;
    this.methodSelectMode = true;
    this.confirmMode = false;
  }

  clearError(){
    this.errorMsg = false;
  }


}
